import { motion } from "framer-motion";
import { MaskLines } from "./Reveal";

export const PageHero = ({ eyebrow, lines, intro, image }) => (
  <section className="relative overflow-hidden bg-ink pb-20 pt-40 text-sand grain sm:pb-28">
    {image && (
      <motion.img
        src={image}
        alt=""
        aria-hidden="true"
        initial={{ scale: 1.15, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.35 }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 h-full w-full object-cover"
      />
    )}
    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/30" />
    <div className="relative mx-auto max-w-[1440px] px-5 sm:px-10">
      <p className="eyebrow text-amber">{eyebrow}</p>
      <MaskLines lines={lines} className="mt-6 font-display text-5xl font-medium leading-[0.95] tracking-tight sm:text-7xl lg:text-8xl" />
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="mt-8 max-w-xl text-base leading-relaxed text-sand/85 md:text-lg"
        >
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
